
<!-- ==============================
  File Name: PartnerAdd.vue
  Description: Partner Add page
=============================== -->
<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vx-card>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full" v-validate="'required'" name="PrimaryCode" @blur="checkPrimaryCode($event)" label-placeholder="Default code*" v-model="Partner.PrimaryCode" v-on:keyup="checkCode(Partner.PrimaryCode)"/>
             <span class="text-danger text-sm" v-show="errors.has('PrimaryCode') && isSaveForm">The Primary Code field is required.</span>
             <span class="text-danger text-sm" v-if='(isCodeExist || isPrimaryCodeExist) && (Partner.PrimaryCode !="" && Partner.PrimaryCode != null)'>Primary code is already in use.</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full"  v-validate="'required'" name="CompanyName" label-placeholder="Company Name*" v-model="Partner.CompanyName" />
             <span class="text-danger text-sm" v-show="errors.has('CompanyName') && isSaveForm">The Company Name field is required.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full"  v-validate="'required'" name="ShortName" label-placeholder="Short Name*" v-model="Partner.ShortName" />
             <span class="text-danger text-sm" v-show="errors.has('ShortName') && isSaveForm">The Short Name field is required.</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
               <label class="font-sm">Select Partner Type</label>
             <v-select :options="partnerTypeList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" name="PartnerType" v-model="Partner.PartnerType"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full" label-placeholder="Phone" v-model="Partner.Phone" />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input type="text" class="w-full" label-placeholder="PAN" v-model="Partner.PAN" />
          </div>
        </div>
          <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full" type="text" label-placeholder="GST" v-model="Partner.GST" />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label class="font-sm">Address</label>
            <vs-textarea  class="mb-2" v-model="Partner.Address" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
             <label class="font-sm">Select Country</label>
             <v-select :options="countryList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" name="Country" v-model="Partner.Country" v-on:input="getStates($event)"/>
          </div>
           <div class="vx-col sm:w-1/2 w-full mb-6">
             <label class="font-sm">Select State</label>
             <v-select :options="stateList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" name="State" v-model="Partner.State"/>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
             <vs-input class="w-full" type="text" label-placeholder="City" v-model="Partner.City" />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input type="email" class="w-full" label-placeholder="Postal code" name="PostalCode" v-model="Partner.PostalCode" />
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full" label-placeholder="POC Name" name="POCName" v-model="Partner.POCName" />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input type="email" class="w-full" v-validate="'required|email'" name="POCEmail" label-placeholder="POC Email*" v-model="Partner.POCEmail" />
            <span class="text-danger text-sm" v-show="errors.has('POCEmail') && isSaveForm">The POC Email field is required.</span>
          </div>
        </div>
        <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full" label-placeholder="POC Phone" name="POCPhone" v-model="Partner.POCPhone" />
          </div>
           <div class="vx-col sm:w-1/2 w-full mb-6">
            <vs-input type="email" class="w-full" label-placeholder="Company Email" name="CompanyEmail" v-model="Partner.CompanyEmail" />
          </div>
        </div>
          <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <vs-input class="w-full" label-placeholder="Company Phone" name="CompanyPhone" v-model="Partner.CompanyPhone" />
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-6">
            <label class="text-sm">Select Industry</label>
            <v-select
              :options="industryList"
              :dir="$vs.rtl ? 'rtl' : 'ltr'"
              class="w-full"
              name="Industry"
              v-model="Partner.Industry"
            />
            <a href="#" @click="IndustryValue='', industryPopup=true">Add Industry</a>
          </div>
        </div>
          <div class="vx-row">
          <div class="vx-col sm:w-1/2 w-full mb-2">
           <label class="font-sm">Select Reference</label>
             <v-select :options="referenceList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" name="Reference" v-model="Partner.Reference"/>
             <a href="#" @click="ReferenceValue='', referencePopup=true">Add Reference</a>
          </div>
          <div class="vx-col sm:w-1/2 w-full mb-2">
           <label class="font-sm">Select Status</label>
             <v-select :options="statusList" :dir="$vs.rtl ? 'rtl' : 'ltr'" class="w-full" name="Status" v-model="Partner.Status"/>
          </div>
        </div>
        <div class="vx-row mt-5">
          <div class="vx-col w-full">
            <vs-button class="mr-3 mb-2" @click.prevent="savePartner">Save</vs-button>
            <vs-button color="warning" type="border" class="mb-2" @click.native="$router.push('/apps/partners/list')">Cancel</vs-button>
          </div>
        </div>
      </vx-card>
      <div class="demo-alignment">
      <vs-popup classContent="popup-example" title="Add Industry" :active.sync="industryPopup">
        <vs-row>
          <vs-col
            vs-offset="4"
            vs-justify="center"
            vs-align="center"
            class="vx-col w-full mb-2"
            >
            <vs-input
              class="mb-3 sm:mb-3"
              label-placeholder="Add Industry:"
              v-model="IndustryValue"
              name="Name"
            />
            <span
              class="text-danger text-sm w-full"
              v-show="errors.has('Name')"
            >{{ errors.first('Name') }}.</span>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col
            vs-offset="4"
            vs-type="flex"
            vs-justify="center"
            class="mb-4 md:mb-3"
            vs-align="center"
            vs-w="4"
          >
            <vs-button
              vs-offset="6"
              vs-type="flex"
              vs-justify="center"
              @click="save_settings('Industry', IndustryValue), industryPopup=false"
              class="mr-2 mb-3"
            >Save</vs-button>
            <vs-button
              vs-offset="4"
              vs-type="flex"
              vs-justify="center"
              color="warning"
              type="border"
              class="mr-2 mb-3"
              @click="industryPopup=false; resetSetting()"
            >Cancel</vs-button>
          </vs-col>
        </vs-row>
      </vs-popup>
    </div>
    <div class="demo-alignment">
      <vs-popup classContent="popup-example" title="Add Reference" :active.sync="referencePopup">
        <vs-row>
          <vs-col
            vs-offset="4"
            vs-justify="center"
            vs-align="center"
            class="vx-col w-full mb-2"
            >
            <vs-input
              class="mb-3 sm:mb-3"
              label-placeholder="Add Reference:"
              v-model="ReferenceValue"
              name="Name"
            />
            <span
              class="text-danger text-sm w-full"
              v-show="errors.has('Name')"
            >{{ errors.first('Name') }}.</span>
          </vs-col>
        </vs-row>
        <vs-row>
          <vs-col
            vs-offset="4"
            vs-type="flex"
            vs-justify="center"
            class="mb-4 md:mb-3"
            vs-align="center"
            vs-w="4"
          >
            <vs-button
              vs-offset="6"
              vs-type="flex"
              vs-justify="center"
              @click="save_settings('Reference', ReferenceValue), referencePopup=false"
              class="mr-2 mb-3"
            >Save</vs-button>
            <vs-button
              vs-offset="4"
              vs-type="flex"
              vs-justify="center"
              color="warning"
              type="border"
              class="mr-2 mb-3"
              @click="referencePopup=false; resetSetting()"
            >Cancel</vs-button>
          </vs-col>
        </vs-row>
      </vs-popup>
    </div>
    </div>
  </div>
</template>

<script>
import  '@/assets/css/main.css'
import CountryData from '@/assets/utils/countries.json'
import PartnerService from "@/services/PartnerService";
import PartnerCodesService from "@/services/PartnerCodesService";
import SettingsService from "@/services/SettingsService";
import UtilService from "@/services/UtilService";
import vSelect from 'vue-select'

export default{
    components: {
     'v-select': vSelect,
  },
  data () {
    return {
      userInfo: {},
      Partner:{
        Id: '', 
        PrimaryCode: '',
        CompanyName: '',
        ShortName: '',
        PartnerType: '',
        Phone: '',
        PAN: '',
        GST: '',
        Address: '',
        Country: '',
        State: '',
        City: '',
        PostalCode: '',
        POCName: '',
        POCEmail: '',
        POCPhone: '',
        CompanyEmail: '',
        CompanyPhone: '',
        Industry: '',
        Reference: '',
        Status: 'Active',
        IsDeleted: 0,
        CreatedBy: '',
        ModifiedBy: '',
      },
       Code:{
        Id: '', 
        Partner: '',
        CodeName: '',
        StartDate: '',
        ExpiryDate: '',
        Primary: 'Yes',
        IsDeleted: 0,
        CreatedBy: '',
        Status:'Active',
        ModifiedBy: '',
      },
      Settings: {
        Id: "",
        Name: "",
        Type: "",
        Status: "Active",
        IsDeleted: 0,
        CreatedDate: Date,
        CreatedBy: "",
        ModifiedDate: Date,
        ModifiedBy: ""
      },
      partnerTypeList: ['AFFILIATE PARTNER', 'CHANNEL PARTNER','INTEGRATION PARTNER','RESELLER'],
      countryList: [],
      stateList: [],
      industryList: [],
      referenceList: [],
      statusList: ['Active','InActive'],
      isSaveForm: false,
      isCodeExist:false,
      isPrimaryCodeExist:false,
      oldCodeValue: '',
      industryPopup:false,
      referencePopup: false,
      referenceValue:"",
      industryValue: "",
    }
  },
  watch: {
    '$route' (to, from) {
      // Reset form here
        this.Partner = {
        Id: '', 
        PrimaryCode: '',
        CompanyName: '',
        ShortName: '',
        PartnerType: '',
        Phone: '',
        PAN: '',
        GST: '',
        Address: '',
        Country: '',
        State: '',
        City: '',
        PostalCode: '',
        POCName: '',
        POCEmail: '',
        POCPhone: '',
        CompanyEmail: '',
        CompanyPhone: '',
        Industry: '',
        Reference: '',
        Status: 'Active',
        IsDeleted: 0,
        CreatedBy: '',
        ModifiedBy: '',
      }
    },
  },
  methods: {
     checkPrimaryCode(event){
       this.isPrimaryCodeExist = false
       this.isCodeExist = false
      if(event.target.value!==''){
       PartnerService.checkIfCodeExists(event.target.value).then((obj) => {
        if(obj.val()){
          this.isPrimaryCodeExist = true
          return 
        } else{
          this.isPrimaryCodeExist = false
        }
      })
      PartnerCodesService.checkDuplicateCode(event.target.value).then((obj) => {
        if(obj.val()){
          this.isCodeExist = true
          return 
        } else{
          this.isCodeExist = false
        }
      })
      }
    },
    checkCode(PrimaryCode){
      this.Partner.PrimaryCode = PrimaryCode.toUpperCase();
      let char = String.fromCharCode(PrimaryCode); 
      if(/[A-Za-z0-9]/.test(char)) return true; 
      else return false; 
    },
      fetchPartnerData(partnerId) {
      PartnerService.getById(partnerId).once("value", (item) => {
        if(item && item.val()){ 
          this.Partner = item.val();
          this.oldCodeValue = this.Partner.PrimaryCode
        }
      });
    },
    savePartner(){
      this.isSaveForm = true;
      this.$validator.validateAll().then(result => {
        if(result && !this.isCodeExist && !this.isPrimaryCodeExist) {
          if(this.Partner['Id']){ 
            this.Partner["ModifiedBy"] = this.userInfo['Id'];
            PartnerService.update(this.Partner['Id'], this.Partner)
              .then(() => {
                PartnerCodesService.getCodesId(this.oldCodeValue).once("value", (items) => {
                  items.forEach((item)=>{
                    PartnerCodesService.updateCode(item.val()['Id'], this.Partner['PrimaryCode'], this.userInfo['Id'], true)
                  }) 
                  UtilService.notifySuccessAlert(this.$vs, 'Partner updated successfully.');
                  this.fetchPartnerData(this.$route.params.partnerId);
                  this.$router.push('/apps/partners/list');
                });
              })
              .catch(e => {
                console.log(e);
              });
          }else{
            this.Partner["CreatedBy"] = this.userInfo['Id'];
            PartnerService.create(this.Partner)
              .then((obj) => {
                if(!obj.val()){
                  this.Code['Partner'] = this.Partner['Id']
                  this.Code['CodeName'] = this.Partner['PrimaryCode']
                  this.Code['StartDate'] = this.Partner['CreatedDate']
                  this.Code['CreatedBy'] = this.userInfo['Id']
                  this.Code['IsDefault'] = true
                  PartnerCodesService.create(this.Code)
                  UtilService.notifySuccessAlert(this.$vs, 'Partner created successfully.');
                  this.$router.push('/apps/partners/list');
                } else {
                  UtilService.notifyErrorAlert(this.$vs, 'Partner already exists.');
                }
              })
              .catch(e => {
                console.log(e);
              });
          }
        }
        else{
          UtilService.notifyErrorAlert(
            this.$vs,
            "Please fill all mandatory fields."
          );
        }
      })
    },
    checkIsExists(type, callback){
      let array = [];
      let isExist = false;
      if(type === 'Industry'){
        array = this.industryList;
      } else if(type === 'Reference'){
        array = this.referenceList;
      }
      array.forEach((item, i) => {
        if(item && item.toLowerCase().trim() === this.Settings['Name'].toLowerCase().trim()){ 
          isExist = true;
        }
      });
      callback(isExist);
    },
    resetSetting(){
      this.Settings = {
        Id: "",
        Name: "",
        Type: "",
        Status: "Active",
        IsDeleted: 0,
        CreatedDate: Date,
        CreatedBy: "",
        ModifiedDate: Date,
        ModifiedBy: ""
      }
    },
    save_settings(type, name) {
          this.Settings['Name'] = name;
          this.Settings['Type'] = type;
          this.checkIsExists(type, (isExist) => {
            if(isExist){
              UtilService.notifyErrorAlert(
                this.$vs,
                type + " already exists."
              );
            } else {
              if(type === 'Industry'){
                this.Partner.Industry = name;
                this.industryPopup = false;
              } 
              else if(type === 'Reference'){
                this.Partner.Reference = name;
                this.referencePopup = false;
              }
              if (this.Settings["Id"]) {
                this.Settings["ModifiedBy"] = this.userInfo['Id'];
                SettingsService.update(this.Settings["Id"], this.Settings)
                  .then(() => {
                    this.resetSetting();
                    UtilService.notifySuccessAlert(
                        this.$vs,
                      "Settings updated successfully."
                    );
                  })
                  .catch(e => {
                      console.log(e);
                  });
              } else {
                this.Settings["CreatedBy"] = this.userInfo['Id'];
                SettingsService.create(this.Settings)
                  .then(obj => {
                    this.resetSetting();
                    if (!obj.val()) {
                      UtilService.notifySuccessAlert(
                        this.$vs,
                        "Settings created successfully."
                      );
                    } else {
                      UtilService.notifyErrorAlert(
                        this.$vs,
                        "Settings already exists."
                      );
                    }
                  })
                  .catch(e => {
                    console.log(e);
                  });
              }
            }
          })
    },
     getSettings() {
      SettingsService.getAll().on("value", items => {
        this.industryList = [];
        this.referenceList = [];
        items.forEach(item => {
          let key = item.key;
          let data = item.val();
          if (data["Type"] == "Industry") {
            this.industryList.push(data["Name"]);
          } else if (data["Type"] == "Reference") {
            this.referenceList.push(data["Name"]);
          } 
        });
        this.industryList.sort((a, b) => a.localeCompare(b))
        this.referenceList.sort((a, b) => a.localeCompare(b))
      });
    },
  getCountryData(){
    this.countryList = []
    CountryData.countries.forEach((item) => {
       this.countryList.push(item.country)
    })
  },
  getStates(e){
    this.Partner.State = ''
    this.stateList = []
    let statesData = CountryData.countries.filter((item) => {
      return item.country === e
    })
    this.stateList.push(...statesData[0].states)
  }
  },
  created() {
    this.getSettings();
    this.getCountryData();
    const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.userInfo = userInfo;
    if(this.$route.params.partnerId){
      this.fetchPartnerData(this.$route.params.partnerId);
    }

  }
}
</script>
